/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo model module.
 * @module model/MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo
 * @version 1.0
 */
class MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo {
    /**
     * Constructs a new <code>MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo</code>.
     * @alias module:model/MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo
     */
    constructor() { 
        
        MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo} obj Optional instance to populate.
     * @return {module:model/MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo} The populated <code>MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo();

            if (data.hasOwnProperty('missionNo')) {
                obj['missionNo'] = ApiClient.convertToType(data['missionNo'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('conditionAt')) {
                obj['conditionAt'] = ApiClient.convertToType(data['conditionAt'], 'Date');
            }
            if (data.hasOwnProperty('dailyData')) {
                obj['dailyData'] = ApiClient.convertToType(data['dailyData'], 'String');
            }
            if (data.hasOwnProperty('achievementData')) {
                obj['achievementData'] = ApiClient.convertToType(data['achievementData'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['dailyData'] && !(typeof data['dailyData'] === 'string' || data['dailyData'] instanceof String)) {
            throw new Error("Expected the field `dailyData` to be a primitive type in the JSON string but got " + data['dailyData']);
        }
        // ensure the json data is a string
        if (data['achievementData'] && !(typeof data['achievementData'] === 'string' || data['achievementData'] instanceof String)) {
            throw new Error("Expected the field `achievementData` to be a primitive type in the JSON string but got " + data['achievementData']);
        }

        return true;
    }


}



/**
 * @member {Number} missionNo
 */
MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo.prototype['missionNo'] = undefined;

/**
 * @member {Date} beginAt
 */
MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo.prototype['endAt'] = undefined;

/**
 * @member {Date} conditionAt
 */
MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo.prototype['conditionAt'] = undefined;

/**
 * @member {String} dailyData
 */
MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo.prototype['dailyData'] = undefined;

/**
 * @member {String} achievementData
 */
MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo.prototype['achievementData'] = undefined;

/**
 * @member {Date} createdAt
 */
MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo.prototype['createdAt'] = undefined;






export default MissionControllerDtoMissionFreeInfoListBasicMissionFreeInfo;

